import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class SplunkLogsService {
    public apiUrl:any;
    constructor(private http: HttpClient) {
        this.apiUrl = window['__env'].apiUrl;
    }

    // send additional logs to server
    additionalLogs(requestObj: any) {
        return this.http.post(`${this.apiUrl}/loggerService/addLogs`, requestObj);
    }

    supplierSmmaryMailLogs(requestObj: any) {
      return this.http.get(`${this.apiUrl}/loggerService/addSuppSummaryLogs?viewFlag='+requestObj.viewFlag +'&supplierName='+requestObj.supplierName +'&emailId='+requestObj.emailId+ '&userId='+requestObj.userId`);
    }
    // report issues changes
    viewAllIssues() {
        return this.http.get(`${this.apiUrl}/issueReporterService/viewAllReportIssues`);
    }

    submitFeedback(requestObj: { moduleType: string[]; comment: string; supplierName?: string }) {
        return this.http.post(`${this.apiUrl}/feedback`, requestObj);
    }

    getFeedbackHistory() {
        return this.http.get(`${this.apiUrl}/feedback/history`);
    }

    getUnreadCount() {
        return this.http.get(`${this.apiUrl}/feedback/unread-count`);
    }

    markFeedbackRead(id: number) {
        return this.http.put(`${this.apiUrl}/feedback/markRead/${id}`, {});
    }

    submitFeedbackWithImages(formData: FormData) {
        return this.http.post(`${this.apiUrl}/feedback`, formData);
    }

    downloadFeedbackImage(feedbackId: string, imageId: number) {
        return this.http.get(`${this.apiUrl}/feedback/${feedbackId}/images/${imageId}`, {
            responseType: 'blob'
        });
    }
}
